import { render, staticRenderFns } from "./UsersList.vue?vue&type=template&id=3f13be2e"
import script from "./UsersList.vue?vue&type=script&lang=js"
export * from "./UsersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports